import React from 'react'
import moment from 'moment'
import { BaseDisplayItemProps } from '../BaseDisplayItem'
import {
    BaseDateField,
    DateFieldExtendedState,
    DateFieldItem,
    DateFieldValue,
    serializeDateTimeValue,
} from '../shared/date'
import { DateTimeFieldEdit } from './DateTimeFieldEdit'
import { DateTimeFieldSearch } from './DateTimeFieldSearch'
import { formatDateTimeValue, getDateTimeLocale } from './formatDateTimeValue'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface DateTimeFieldProps
    extends BaseDisplayItemProps<DateTimeValue, DateTimeItem> {}

export type DateTimeValue = DateFieldValue
export type DateTimeItem = DateFieldItem
export type DateTimeFieldExtendedState = DateFieldExtendedState

class DateTimeField extends BaseDateField {
    constructor(props: DateTimeFieldProps) {
        super(props, 'datetime')
    }

    protected serializeValue(m: moment.Moment): string {
        return serializeDateTimeValue(m)
    }

    renderEdit(): React.ReactNode {
        return (
            <DateTimeFieldEdit
                kedo={this.kedo}
                state={this.state}
                errors={this.props.errors}
                value={this.state.value}
                onChangeDate={this.onChangeDate}
                isInvalid={this.isInvalid}
                getErrorText={this.getErrorText}
                getCurrentLocale={this.getCurrentLocale}
            />
        )
    }

    renderSearch(): React.ReactNode {
        return (
            <DateTimeFieldSearch
                kedo={this.kedo}
                date1={this.state.date1}
                date2={this.state.date2}
                searchType={this.state.searchType}
                show_slider={this.state.show_slider}
                onChangeSearch={this.onChangeSearch}
                onChangeDate={this.onChangeDate}
                isInvalid={this.isInvalid}
                getErrorText={this.getErrorText}
            />
        )
    }
}

export default DateTimeField
